module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('detail-layout', {
    ref: "layout",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "FormLayout",
      fn: function(props) {
        return [_c('b-form', {
          ref: "form",
          staticClass: "offset-md-1",
          attrs: {
            "autocomplete": "off"
          }
        }, [(_vm.dataValid) ? _c('div', [_c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Invoice/Contract/Student",
            "field": "invoice_id",
            "optionListApiUrl": '/invoices/choice/',
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Amount Paid",
            "field": "amount_paid",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onCalcNetAmount(props.rec, $event)
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Commission",
            "field": "commission",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          },
          on: {
            "input": function($event) {
              _vm.onCalcNetAmount(props.rec, $event)
            }
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Net Amount",
            "field": "net_amount",
            "rec": props.rec,
            "isReadOnly": true,
            "type": "money",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Payment Date",
            "field": "payment_date",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "type": "date",
            "vvalidate": "required",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Comments",
            "field": "comments",
            "type": "textarea",
            "rec": props.rec,
            "isReadOnly": _vm.isReadOnly,
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1), _vm._v(" "), (!_vm.isNew) ? _c('div', {
          staticClass: "row"
        }, [_c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Created",
            "field": "creation_timestamp",
            "field2": "creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "Last Edit",
            "field": "edit_timestamp",
            "field2": "edit_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          staticClass: "col-md-6",
          attrs: {
            "label": "PDF Creation",
            "field": "pdf_creation_timestamp",
            "field2": "pdf_creation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        }), _vm._v(" "), _c('detail-field', {
          attrs: {
            "vclass": "col-md-6",
            "label": "Payment Confirmation",
            "field": "payment_confirmation_timestamp",
            "field2": "payment_confirmation_user",
            "static": true,
            "rec": props.rec,
            "isReadOnly": true,
            "type": "timestamp_user",
            "vvalidate": "ok",
            "validator": _vm.validator
          }
        })], 1) : _vm._e()]) : _vm._e()])]
      }
    }, {
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), (props.rec && _vm.privDeveloper && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.createPDF(props.rec)
            }
          }
        }, [_vm._v("Create PDF")]) : _vm._e(), _vm._v(" "), (props.rec && props.rec.number !== null && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.downloadPDF(props.rec)
            }
          }
        }, [_vm._v("Download PDF")]) : _vm._e(), _vm._v(" "), (props.rec && props.rec.number !== null && _vm.privUser && _vm.isReadOnly) ? _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.sendEmail(props.rec)
            }
          }
        }, [_vm._v("Send Payment Confirmation")]) : _vm._e()], 2)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69df0728"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/InvoicePayment/Detail.vue
// module id = 710
// module chunks = 1